export default __webpack_public_path__ + "static/media/StoreFront.176acb83.mov";